import getRandomValues from 'get-random-values';

const cryptographicallyRandomValue = () => {
  const array = new Uint8Array(1);
  getRandomValues(array);
  // Divide by the full range of uint8.
  return array[0] / (0xff + 1);
};

export default cryptographicallyRandomValue;



// WEBPACK FOOTER //
// ./src/utilities/cryptographicallyRandomValue.js